import { render, staticRenderFns } from "./ActorMiniature.vue?vue&type=template&id=5e1cb891&"
import script from "./ActorMiniature.vue?vue&type=script&lang=ts&"
export * from "./ActorMiniature.vue?vue&type=script&lang=ts&"
import style0 from "./ActorMiniature.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports